import dayjs from 'dayjs';

import { useTimeFormat, useUpdateUserPreferences } from '../../../../hooks/accounts';

import { RadioButton, RadioHeader } from '@controlrooms/components';

export enum TimeFormatOptions {
  TWENTY_FOUR_HOUR = '24h',
  TWELVE_HOUR = '12h',
}

const getTimeFormatLabel = (option: TimeFormatOptions): string => {
  const currentTime = dayjs();

  if (option === TimeFormatOptions.TWENTY_FOUR_HOUR) {
    return `24 Hour (${currentTime.format('HH:mm')})`;
  }

  return `12 Hour (${currentTime.format('h:mm A')})`;
};

export const TimeFormat: React.FC = () => {
  const optionValues = Object.values(TimeFormatOptions);
  const currentTimeFormat = useTimeFormat();
  const { mutate: updateUserPreferences } = useUpdateUserPreferences();

  return (
    <div>
      Select your preferred time display format.
      <div>
        <br />
        <RadioHeader>Time Format</RadioHeader>
        {optionValues.map((key) => (
          <div data-testid={`${key}-time-format-radio`} key={key}>
            <RadioButton
              checked={currentTimeFormat === key}
              id={`${key}-time-format`}
              value={key}
              onChange={() => {
                updateUserPreferences({ timeFormat: key });
              }}
              key={key}
            >
              {getTimeFormatLabel(key)}
            </RadioButton>
          </div>
        ))}
      </div>
    </div>
  );
};
